<template>
  <v-dialog persistent v-model="showDialog" max-width="450">
    <template v-slot:activator="{props}">
      <v-btn
          v-bind="props"
          base-color="blue-darken-1"
          variant="elevated"
          flat
          class="ml-5"
          prepend-icon="fa fa-plus fa-sm"
          rounded
          text="Add Project">
      </v-btn>
    </template>

    <v-card>
      <v-card-title><b>New Project</b></v-card-title>
      <v-divider/>
      <v-card-text>
        Please enter a name for the new project:
        <v-text-field
            rounded
            variant="solo-filled"
            prepend-inner-icon="fas fa-add px-5"
            bg-color="#e1e7f7"
            single-line
            :rules="rules"
            flat
            class="mt-3"
            placeholder="Enter a project name..."
            v-model="itemAddName"
        />
      </v-card-text>
      <v-divider/>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red" rounded @click="cancel">Cancel</v-btn>
        <v-btn class="px-4" color="blue-darken-4" rounded @click="submitNewProject" variant="flat">
          <v-progress-circular indeterminate size="small" v-if="isLoading" />
          CONFIRM ADD
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
  import {ref} from "vue";
  import {router} from "@inertiajs/vue3";
  import * as $routes from "@/packs/routes";

  const props = defineProps({

    /**
     * Array of objects used in project cloning (and maybe project adding), for duplicate checking.
     * Every item of the array must include the `name` property.
     */
    items: {
      type: Array,
      required: true
    },

    /**
     * Used for the purpose of the tooltip. It's usually a literal like 'Project' or 'KPI'.
     */
    descriptiveName: {
      type: String,
      required: true
    },

    /**
     * List of callback methods used as a Vuetify rule, for the text
     * field that handles the project-clone name.
     */
    rules: {
      type: Array,
      required: true
    }
  });

  const showDialog = ref(false);
  const itemAddName = ref('');
  const isLoading = ref(false);

  const submitNewProject = () => {
    if (!itemAddName.value) return;
    if (props.items.some((item) => item.name === itemAddName.value)) return;

    isLoading.value = true;

    router.post($routes.projects(), {name: itemAddName.value}, {
      onSuccess: () => {
        router.visit($routes.projects());
        isLoading.value = false;
      },
    });

  };

  const cancel = () => {
    showDialog.value = false;
    itemAddName.value = '';
  };

</script>
